import React from "react";

import { getEnvironmentVariable } from "@/common/services/env";

const Metadata = ({ title }: { title?: string }) => {
  const appMode = getEnvironmentVariable("APP_MODE");
  const titleAppMode =
    appMode === "production" ? "" : `[${appMode.toUpperCase()}] `;
  // eslint-disable-next-line lingui/no-unlocalized-strings
  const titleSlug = titleAppMode + "Clever˚Analytics'";

  React.useEffect(() => {
    document.title = titleSlug + (title ? ` | ${title}` : "");

    return () => {
      document.title = titleSlug;
    };
  }, [title, titleSlug]);

  return null;
};

export { Metadata };
